<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月18日 15:46:35 +0800
 * @最后修改时间: 2022-04-07 13:17:24
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimRecord\editClaimRecord.vue
-->

<template>
  <ContentLayout
    pad="0"
    :title="$t('label_essweb_ClaimRecord_form_viewTitle')"
    widthClass="max-1000"
    backgroundClass="transparent"
  >
    <template v-slot:nav-actions>
      <v-btn
        class="primary mr-4"
        rounded
        @click="showEditPaymentStatus = true"
        >{{ $t("label_essweb_ClaimRecord_form_changeStatusLabel") }}</v-btn
      >
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <ApprovalTriger
        v-if="ClaimRecordData"
        :bg-color="ClaimRecordData.approval_bg_color"
        :slide-color="ClaimRecordData.approval_tint_color"
        @triger="
          $toPage(
            '/admin/claim-record/detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{
            $getDateTime(
              ClaimRecordData.operate_utc_datetime,
              "YYYY/MM/DD HH:mm"
            )
          }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(ClaimRecordData.status_detail) }}
        </template>
      </ApprovalTriger>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        backgroundColor="transparent"
        contentBackground="mrc-grey pa-0"
      >
        <template v-slot:content-1>
          <Section isStart>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :filled="false"
                    :readonly="true"
                    v-model="ClaimRecordData.swift_number"
                    :label="
                      $t('label_essweb_ClaimRecord_form_swiftNumberLabel')
                    "
                    isNotRequire
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :filled="false"
                    :readonly="true"
                    :value="
                      $getDateTime(
                        ClaimRecordData.submission_utc_datetime,
                        'YYYY/MM/DD HH:mm'
                      )
                    "
                    :label="$t('label_essweb_ClaimRecord_form_createdOnLabel')"
                    isNotRequire
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :filled="false"
                    :readonly="true"
                    :value="
                      $getCommonLangValue(ClaimRecordData.claim_type_name)
                    "
                    :label="$t('label_essweb_ClaimRecord_form_claimTypeLabel')"
                    isNotRequire
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <AutoComplete
                    label="label_essweb_leaveApplication_form_applicantLabel"
                     v-model="user"
                    readonly
                    :items="users"
                    chips
                    avatar
                    small-chips
                    two-line
                    item-value="uuid"
                    item-text="preferred_name"
                  >
                    <template v-slot:selection.avatar="{ data }">
                      <StaffAvatar
                        :src="data.item.staff_avatar"
                        left
                        small
                        :isTemp="data.item.is_temp"
                        :staff_name="data.item.preferred_name"
                      />
                    </template>
                   
                  </AutoComplete>
                
                </v-col>
              </v-row>
            </v-form>
          </Section>
          <!-- payment -->
          <Section>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :filled="false"
                    :readonly="true"
                    :value="
                      $getCommonLangValue(ClaimRecordData.payment_status_detail)
                    "
                    :label="
                      $t('label_essweb_ClaimRecord_form_paymentStatusLabel')
                    "
                    isNotRequire
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :filled="false"
                    :readonly="true"
                    :value="
                      $getCommonLangValue(ClaimRecordData.payment_method_detail)
                    "
                    :label="
                      $t('label_essweb_ClaimRecord_form_paymentMethodsLabel')
                    "
                    isNotRequire
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :filled="false"
                    :readonly="true"
                    :value="
                      $getCommonLangValue(ClaimRecordData.payment_reference)
                    "
                    :label="
                      $t('label_essweb_ClaimRecord_form_paymentReferenceLabel')
                    "
                    isNotRequire
                  />
                </v-col> </v-row
            ></v-form>
          </Section>
          <!-- info -->
          <Section>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :filled="false"
                    :readonly="true"
                    :value="
                      $getCommonLangValue(ClaimRecordData.claim_form_name)
                    "
                    :label="
                      $t('label_essweb_ClaimRecord_form_claimFormTitleLabel')
                    "
                    isNotRequire
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :filled="false"
                    :readonly="true"
                    :value="
                      $getCommonLangValue(
                        ClaimRecordData.claim_form_description
                      )
                    "
                    :label="
                      $t(
                        'label_essweb_ClaimRecord_form_claimFormDescriptionLabel'
                      )
                    "
                    isNotRequire
                  />
                </v-col> </v-row
            ></v-form>
          </Section>
        </template>
        <template v-slot:content-2>
            <!-- amount -->
            <v-card class="pa-0  elevation-0 primary lighten-4 rounded-lg">
              <v-card-text>
                <div class="text-left text-h6  text--primary">
                  {{
                    $t("label_essweb_ClaimRecord_form_claimTotalAmountLabel")
                  }}
                </div>
                <div class="text-right text-h5  text--primary">
                  {{ currency_code }}
                  {{ $get_thousand_num(parseFloat(Number(claim_total_amount).toFixed(4))) }}
                </div>
              </v-card-text>
            </v-card>
            <Section>
                <Tabler :headers="headers" :items="desserts" border>
                  <template v-slot:item.type="{ item }">
                    {{ $getCommonLangValue(item.claim_item_type_name) }}
                  </template>
                  <template v-slot:item.name="{ item }">
                    {{ $getCommonLangValue(item.claim_item_name) }}
                  </template>
                  <template v-slot:item.actual_amount="{ item }">
                    <span v-if="Number(item.is_show_actual_amount)">
                      {{ item.actual_currency_code }}
                      {{ $get_thousand_num(parseFloat(Number(item.actual_amount).toFixed(4))) }}
                    </span>
                  </template>
                  <template v-slot:item.claim_amount="{ item }">
                    {{ item.claim_currency_code }}
                    {{ $get_thousand_num(parseFloat(Number(item.claim_amount).toFixed(4))) }}
                  </template>
                  <template v-slot:item.approval_amount="{ item }">
                    {{ currency_code }}
                    {{ $get_thousand_num(parseFloat(Number(item.approved_amount).toFixed(4))) }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn icon @click="toViewItem(item.uuid)">
                      <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
                    </v-btn>
                  </template>
                </Tabler>
              </v-card-text>
            </v-card>
          </Section>
        </template>
      </Taber>
    </template>
    <!-- tools -->
    <template v-slot:tools-main>
      <editPaymentStatus
        :show="showEditPaymentStatus"
        @close="showEditPaymentStatus = false"
        @save="onSave"
        :method="ClaimRecordData.payment_method"
        :status="ClaimRecordData.payment_status_uuid"
        :reference="ClaimRecordData.payment_reference"
      />
      <viewClaimItem
        :show="showClaimItem"
        @close="
          showClaimItem = false;
          curUuid = null;
        "
        :curUuid="curUuid"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import editPaymentStatus from "@/Page/EssAdmin/Claim/ClaimRecord/components/editPaymentStatus.vue";
import viewClaimItem from "@/Page/EssAdmin/Claim/ClaimRecord/components/viewClaimItem.vue";

export default {
  name: "editClaimRecord",
  components: { editPaymentStatus, viewClaimItem },
  computed: {},
  data() {
    return {
      users: [],
      showEditPaymentStatus: false,
      showClaimItem: false,
      curUuid: null,
      user: null,
      curTab: "tab-1",
      taber: [
        "label_essweb_ClaimRecord_form_tab_formInfoLabel",
        "label_essweb_ClaimRecord_form_tab_claimItemLabel",
      ],
      headers: [
        {
          text: "label_essweb_ClaimRecord_form_dialog_claimItemTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_claimItemNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_actualAmountLabel",
          value: "actual_amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_claimAmountLabel",
          value: "claim_amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_approvalAmountLabel",
          value: "approval_amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      page_params: null,
      ClaimRecordData: {
        uuid: "",
        claim_form_name: "",
        claim_form_description: "",
        submission_utc_datetime: "",
        submission_date_time_zone: "",
        remarks: "",
        operate_utc_datetime: "",
        approval_status: "",
        claim_total_amount: "",
        currency_name: "",
        currency_code: "",
        currency_symbol: "",
        staff_id: "",
        staff_image: "",
        staff_name: "",
        ess_claim_form_record_items: [],
      },
      claim_total_amount: 0,
      currency_code: "",
    };
  },
  watch: {},
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.getDetail();
    this.getClaimItem();
  },
  methods: {
    toViewItem: function (uuid) {
      this.curUuid = uuid;
      this.showClaimItem = true;
    },
    onSave: function (obj) {
      const that = this;
      this.showEditPaymentStatus = false;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_form_records",
        url: "/claim-records/change-payment-status/",
        data: {
          uuid: this.page_params.id,
          payment_status_uuid: obj.payment_status_uuid,
          payment_method: obj.payment_method,
          payment_reference: obj.payment_reference,
        },
      }).then((res) => {
        that.getDetail();
      });
    },
    getClaimItem: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_form_record_items",
        url: "/claim-record-items/get-claim-record-items-list/",
        data: {
          claim_form_record_uuid: this.page_params.id,
        },
      }).then((res) => {
        that.claim_total_amount = res.data["claim_total_amount"];
        that.currency_code = res.data["currency_code"];
        that.desserts = res.data["ess_clm_claim_form_record_items"];
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_form_records",
        url: "/claim-records/get-claim-records-details/",
        data: { uuid: this.page_params.id },
      }).then((res) => {
        that.user = res.data.uuid;
        that.users = [
          {
            staff_avatar: res.data.agent_staff.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.agent_staff.preferred_name,
          },
        ];
        that.ClaimRecordData = res.data;
      });
    },
  },
};
</script>
